import { useSelector } from "react-redux";
import { RootState } from "../state/reducers";

export const useCommonSelectedHook = () => {
    const { dm_truong_selected_id, nam_hoc, hoc_ky, dm_he_selected_id,dm_coso_selected_id } = useSelector((x: RootState) => x.common);

    return {
        dm_truong_id: dm_truong_selected_id,
        nam_hoc,
        hoc_ky,
        dm_he_id: dm_he_selected_id,
        dm_coso_id: dm_coso_selected_id
    };
}
